<template>
  <div class="place pt-[98px]">
    <AdenTitle class="mb-[52px]" :titles="['登陆特色小岛，体验当地文化，深入城市腹地', '去发现那里的精彩人文与悠长历史']"></AdenTitle>
    <div class="place__content">
      <div class="whychoice__content w-full mx-auto relative">
        <swiper class="swiper-no-swiping w-full !pb-[50px]" :options="swiperOptions">
          <swiper-slide v-for="(item, index) in list" :key="index">
            <div class="w-[900px] h-[522px] relative">
              <img class="w-[900px] h-[522px] object-cover" :src="item.img" />
              <div class="absolute left-[15px] bottom-[20px] text-white">
                <i class="ficon ficon-dangqianweizhi mr-[2px]"></i>
                <span>{{  item.city  }}</span>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>

        <div class="n-swiper-button-prev swiper__page" slot="button-prev">
          <i class="ficon ficon-arrow-left text-dark leading-0"></i>
        </div>
        <div class="n-swiper-button-next swiper__page" slot="button-next">
          <i class="ficon ficon-arrow-right text-dark leading-0"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@nuxtjs/composition-api";
import AdenTitle from "@/views/topic/202208/aden/components/aden-title.vue";


export default defineComponent({
  name: "CulturePace",
  components: {
    AdenTitle
  },
  data() {
    return {
      swiperOptions: {
        // lazy: {
        //   loadPrevNext: true
        // },
        loop: true,
        // slidesPerView: 3,
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 68,
        navigation: {
          prevEl: '.n-swiper-button-prev',
          nextEl: '.n-swiper-button-next',
        },
        pagination: {
          el: ".swiper-pagination",
          cliceable: true
        }
      },
      list: [
        { img: require(`@/views/topic/202208/aden/imgs/place_1.png`), city: "厦门" },
        { img: require(`@/views/topic/202208/aden/imgs/place_2.png`), city: "舟山" },
        { img: require(`@/views/topic/202208/aden/imgs/place_3.png`), city: "三亚" },
        { img: require(`@/views/topic/202208/aden/imgs/place_4.png`), city: "深圳" },
        { img: require(`@/views/topic/202208/aden/imgs/place_5.png`), city: "上海" },
      ]
    };
  },
})
</script>

<style lang="scss" scoped>
.whychoice__content:hover .n-swiper-button-prev .ficon, .whychoice__content:hover .n-swiper-button-next .ficon {
  color: #2D3A4F;
}
.n-swiper-button-prev, .n-swiper-button-next {
  font-size: 2.25rem;
  line-height: 2.5rem;
  position: absolute;
  top: 50%;
  z-index: 10;
  transform: translateY(-50%);
}
.n-swiper-button-prev .ficon, .n-swiper-button-next .ficon {
  color: transparent;
  transition: .2s color ease;
}
.n-swiper-button-prev {
  margin-left: -500px;
  left: 50%;
}
.n-swiper-button-next {
  margin-left: 470px;
  left: 50%;
}
::v-deep .swiper-slide {
  width: 900px;
  height: 522px;
  overflow: hidden;
}
.swiper-pagination {
  --swiper-pagination-color: #C6A14A;
}
</style>
